// If the window size is under 991 pixels, open sub menu on select. Allow navigation to parent menu on selection if sub-menu is open.
function handleMobileMenu(){

    $('.menu-wrapper .level-1-link').on('click', function(e) {

        var id = $(this).siblings('div').attr('id');

        if (Modernizr.mq('(max-width: 991px)')) {
            if ($('#' + id).children().length > 0 && ($("#" + id).hasClass('sub-menu-open'))) {

            } else if ($('#' + id).children().length > 0) {
                e.preventDefault();
                $("#" + id).toggleClass("sub-menu-open");
            }
        } 
    });

    if (Modernizr.mq('(min-width: 992px)')) {
        $('.navbar-nav').find('.sub-menu').removeClass('sub-menu-open');
    }
}